import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { RootState, MyThunkDispatch } from 'store';

import { fetchHasAccess } from 'actions/accessLog';
import useStoreTranslation from 'hooks/useStoreTranslation';
import useToast from 'hooks/useToast';
import { GetAllBillingCompanyResponse } from 'models/billingCompany';
import BranchCompanySelectList from 'screens/components/BillingCompanyList';
import { getAllBillingCompanies, activateOrDesactivateBillingCompany } from 'services/billingCompanyService';

const BranchCompanyContainer = () => {
  const dispatch: MyThunkDispatch = useDispatch();
  const [billingCompanyList, setBillingCompanyList] = useState<GetAllBillingCompanyResponse[]>([]);
  const [isLoading, setLoading] = useState(false);
  const [isSaving, setSaving] = useState(false);
  const toast = useToast();
  const { t } = useStoreTranslation();
  const companyId = useSelector((state: RootState) => state.user.accountResult?.companyId);
  const adminId = useSelector((state: RootState) => (state.user.accountResult ? state.user.accountResult?.id : ''));

  useEffect(() => {
    const screenName = 'ListBranchCompany';
    dispatch(fetchHasAccess(screenName));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminId]);

  const getData = async () => {
    setLoading(true);
    try {
      const res = await getAllBillingCompanies(companyId ?? '');

      if (res.length > 1) {
        setBillingCompanyList(res.slice(1));
      } else {
        setBillingCompanyList(res);
      }
    } catch (error) {
      toast.add({
        type: 'danger',
        message: t('branchCompany.list.errorFetch'),
      });
      setLoading(false);
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleToggle = async (billingCompany: GetAllBillingCompanyResponse) => {
    try {
      setSaving(true);
      await activateOrDesactivateBillingCompany(companyId ?? '', billingCompany.id, !billingCompany.isActive);
      await getData();
    } catch (error) {
      toast.add({
        type: 'danger',
        message: t('branchCompany.list.errorToggle'),
      });
    } finally {
      setSaving(false);
    }
  };
  return (
    <BranchCompanySelectList
      billingCompanyList={billingCompanyList}
      isLoading={isLoading}
      isSaving={isSaving}
      onToggle={handleToggle}
    />
  );
};

export default BranchCompanyContainer;
